import React, { useState } from 'react';
import { t } from 'ttag';
import { Star } from './Star';
import { useLightSwitchesAudioEffect } from '../audio-effect/useLightSwitchesAudioEffect';

interface Props {
  onChange: (value: number) => void;
  name: string;
  ariaLabel: string;
}

export const Stars = ({ onChange, name, ariaLabel }: Props) => {
  const [value, setValue] = useState<number>(0);
  const [playAudioEffect] = useLightSwitchesAudioEffect();

  const handleChange: React.ChangeEventHandler<HTMLInputElement> = e => {
    try {
      playAudioEffect();
    } catch (error) {
      // Silently ignore audio effect errors
    }
    const newValue = parseInt(e.target.value, 10);
    setValue(newValue);
    onChange(newValue);
  };

  return (
    <div role="radiogroup" aria-label={ariaLabel}>
      {[1, 2, 3, 4, 5].map(v => (
        <Star
          key={v}
          value={v}
          name={name}
          active={value >= v}
          checked={value === v}
          ariaLabel={t`${v} out of 5 stars`}
          onChange={handleChange}
        />
      ))}
    </div>
  );
};
